import React, { Component } from 'react';
import {
  Button,
  Icon,
} from 'semantic-ui-react';

export class Widget extends Component {
  state = {
    open: false,
  }

  componentDidMount = () => {
  }

  toggleOpen = () => this.setState({ open: !this.state.open })

  render() {
    if (!this.state.open) {
      return (
        <div className="widget closed">
          <Button
            onClick={this.toggleOpen}
            icon={this.props.icon}
            color={this.props.color}
            onClick={this.toggleOpen}
            size="tiny"
            title={this.props.title}
          />
        </div>
      );
    }

    return (
      <div className="widget open">
        {...this.props.children}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            width: this.props.width ? this.props.width : 600,
          }}
        >
          <Button
            content="Close"
            basic
            onClick={this.toggleOpen}
            style={{
              marginTop: '20px'
            }}
          />
        </div>
      </div>
    );
  }
}
